<div fxFlex="100">

  <mat-card appearance="outlined" fxLayout="column" class="p-16">

    <div *ngIf="!licensed && !verifyingLicense" fxLayout="column" fxLayoutAlign="center center">

      <mat-icon class="icon-60 error" [ngClass]="{'amber-200-fg': iconColor === 'amber', 'red-600-fg': iconColor === 'red'}">warning</mat-icon>

      <div *ngIf="this.license">
        <p>Little SIS is not currently licensed for <strong>{{this.license.domain}}</strong>.</p>
        <p>Your license expired on {{this.license.subscriptions['ait-lsp'].expiry | date: 'MM/dd/yyyy'}}.</p>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center">
        <button mat-button (click)="getQuote()">Get a license</button>
        <button mat-button (click)="verifyLicense(true)">Re-check license</button>
      </div>

    </div>

    <div *ngIf="licensed && !verifyingLicense" fxLayout="column" fxLayoutAlign="center center">

      <div *ngIf="!expiryMessage.length" fxLayoutAlign="center center" fxLayout="row">
        <mat-icon class="icon-60 success">vpn_lock</mat-icon>
      </div>

      <p>
        Little SIS is licensed for <strong>{{this.license.domain}}</strong> until {{this.license.subscriptions['ait-lsp'].expiry | date: 'MM/dd/yyyy'}}.
      </p>

      <div *ngIf="expiryMessage.length" fxLayoutAlign="center center" fxLayout="column">

        <mat-icon class="icon-60" [ngClass]="{'amber-200-fg': iconColor === 'amber', 'red-600-fg': iconColor === 'red'}">warning</mat-icon>
        <p><strong>{{expiryMessage}}</strong></p>
        <button mat-flat-button (click)="getQuote()" [color]="'primary'">Renew your license</button>

      </div>

    </div>

    <div *ngIf="verifyingLicense" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="16px">

      <mat-progress-spinner [diameter]="60"
                            [color]="'primary'"
                            [mode]="'indeterminate'">
      </mat-progress-spinner>

      <div class="loading">
        <span>Checking license</span>
        <animated-ellipsis></animated-ellipsis>
      </div>

    </div>

  </mat-card>

</div>
